import React from "react";
import bank from '../img/bank.png';

export const Home = () => {
  return (
    <div className='home'>
      <div className="header">
        <div className="header-content">
          <img id='logo' src={bank} alt='logo' width='60px' height='60px' />
          <div className="header-text">
            <h1>Aurora Bank</h1>
            <h3>Bank Securely 24x7</h3>
            <p>Your trusted partner in financial services</p>
          </div>
        </div>
      </div>

      <div className="about" id="about">
        <div className="about-section">
          <h2>Welcome to Internet Banking</h2>
          <div className="features">
            <div className="feature">
              <span className="feature-icon">🌐</span>
              <h4>Pan-India Network</h4>
              <p>Access your account from anywhere in India</p>
            </div>
            <div className="feature">
              <span className="feature-icon">⚡</span>
              <h4>Enhanced Services</h4>
              <p>Comprehensive banking solutions at your fingertips</p>
            </div>
            <div className="feature">
              <span className="feature-icon">😊</span>
              <h4>Pleasant Experience</h4>
              <p>User-friendly interface designed for your comfort</p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>About Our Services</h2>
          <p>
            Welcome to the world of internet banking from Aurora Bank, where you
            can transform the way you use banking services. Our platform provides
            secure, simple, and easy-to-use banking solutions that help you carry
            out a variety of banking transactions and access an extensive range of
            features right from where you are, with just a few clicks.
          </p>
          <p>
            With our internet banking solutions, you can now bid goodbye to long
            queues and unwanted delays. Aurora Bank Internet Banking facility
            is secure, simple and easy to use. Use it today to enjoy an
            unparalleled online banking experience.
          </p>
        </div>

        <div className="security-section">
          <h2>Security Guidelines</h2>
          
          <div className="guidelines">
            <div className="guideline-group">
              <h3>✅ Do's</h3>
              <ul>
                <li>
                  Change your password assigned by the bank immediately on accessing
                  Internet Banking Services for the first time.
                </li>
                <li>
                  Keep your user-id and password confidential and do not reveal them
                  to anyone else.
                </li>
                <li>
                  Memorize your user-id and password and do not record them anywhere
                  else.
                </li>
                <li>
                  Always check the URL address on the address bar of internet browser.
                  This should begin with "https"; the letter 's' at the end of "https"
                  means 'secured'.
                </li>
                <li>
                  Install a comprehensive firewall/antivirus/anti-spyware software
                  package on your computer & update the same on a regular basis.
                </li>
              </ul>
            </div>

            <div className="guideline-group">
              <h3>❌ Don'ts</h3>
              <ul>
                <li>
                  Don't use link in an email message to log in. For logging in
                  internet banking always use official website.
                </li>
                <li>
                  Don't let any unauthorized person have access to your computer or
                  leave the computer unattended while using Internet Banking Services.
                </li>
                <li>
                  Don't disclose/reveal your personal or confidential information to
                  anyone over email/SMS/phone call.
                </li>
                <li>
                  Don't enter login or other sensitive information in any pop up
                  window.
                </li>
                <li>
                  Avoid accessing Internet banking accounts from cyber cafes or shared
                  PCs.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-content">
          <p>&copy; 2024 Aurora Bank. All rights reserved.</p>
          <p>Your security is our priority</p>
        </div>
      </div>
    </div>
  );
};
